const vhUnit = () => {
	if(window.innerHeight <= 320) {
		document.documentElement.style.setProperty('--vh', `${320 * 0.01}px`);
		return;
	}

	document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

export default vhUnit;
